import React, { useEffect, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

export const useSignature = (width = 400, height = 200) => {
  const [sign, setSign] = useState();
  const [signature, setSignature] = useState();
  const [signatureContainerWidth, setSignatureContainerWidth] = useState(width);

  const clearSignature = () => {
    sign.clear();
    setSignature("");
  };

  const saveSignature = () => {
    const dataBlug = sign.getTrimmedCanvas().toDataURL("image/png");
    setSignature(dataBlug);
    // sign.clear();
  };

  useEffect(() => {
    if (window.innerWidth <= 560) {
      setSignatureContainerWidth(window.innerWidth - 180);
    }
  }, [signatureContainerWidth]);

  const Signature = (
    <div className='m-20'>
      <div
        className='d-flex justify-content-center align-items-center border border-1'
        style={{ width: signatureContainerWidth + 15, height: height + 15 }}
      >
        <SignatureCanvas
          penColor='black'
          canvasProps={{
            width: signatureContainerWidth,
            height: height,
            className: "sigCanvas",
          }}
          ref={(data) => setSign(data)}
        />
      </div>
    </div>
  );

  return { value: signature, Signature, clearSignature, saveSignature };
};
